import { createXHR } from './utils';
import { startLoadingSpinner, finishLoadingSpinner } from './loading';
import { checkAuthStatusAsync } from './auth';

const NumProductsToLoad = 30;

const init = async () => {
  // NOTE: Hydrate products title from query
  const urlParams = new URLSearchParams(window.location.search);
  const productTitle = document.getElementById('c-product-list__title');
  hydrateElement(productTitle, urlParams);

  // NOTE: Search
  const prodTypeEl = document.getElementById('current-product-type');
  const prodType = JSON.parse(prodTypeEl.innerHTML);

  const searchForm = document.getElementById('global-search');
  searchForm.addEventListener('submit', async (e) => {
    e.preventDefault();

    const value = searchForm.elements.query.value;
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set('query', encodeURIComponent(value));

    if (prodType === 'courses') {
      window.location.search = urlParams.toString();
    } else if (prodType === 'gurus') {
      window.location = '/gurus/?' + urlParams.toString();
    } else if (prodType === 'sheet-music') {
      window.location = '/sheet-music/?' + urlParams.toString();
    } else {
      let res = null;
      res = await getSearchProduct('course', urlParams.toString());
      if (res.length > 0) {
        window.location = '/courses/?' + urlParams.toString();
      }
      res = await getSearchProduct('user/guru', urlParams.toString());
      if (res.length > 0) {
        window.location = '/gurus/?' + urlParams.toString();
      }
      res = await getSearchProduct('song-books', urlParams.toString());
      if (res.length > 0) {
        window.location = '/sheet-music/?' + urlParams.toString();
      }

      if (res && res.length === 0) {
        window.location = '/courses/?' + urlParams.toString();
      }
    }
  })

  const loadMoreWrapper = document.getElementById('load-more-wrapper');
  if (loadMoreWrapper === null) {
    return;
  }
  let loaderInnerHtml = '';

  // NOTE: Check auth status
  loaderInnerHtml = loadMoreWrapper.innerHTML;
  startLoadingSpinner(loadMoreWrapper, true);
  loadMoreWrapper.classList.add('loading');
  const isAuth = await checkAuthStatusAsync();
  finishLoadingSpinner(loadMoreWrapper, loaderInnerHtml, null);
  loadMoreWrapper.classList.remove('loading');
  loaderInnerHtml = '';

  // NOTE: Filters
  const collapseState = {
    genre: {
      isCollapsed: true
    },
    level: {
      isCollapsed: true
    },
    instrument: {
      isCollapsed: true
    },
    type: {
      isCollapsed: true
    }
  };
  const uiEls = {
    genreFieldset: document.getElementById('c-filter__fieldset-genre'),
    genreHeading: document.getElementById('c-filter__heading-genre'),
    levelFieldset: document.getElementById('c-filter__fieldset-level'),
    levelHeading: document.getElementById('c-filter__heading-level'),
    instrumentFieldset: document.getElementById('c-filter__fieldset-instrument'),
    instrumentHeading: document.getElementById('c-filter__heading-instrument'),
    typeFieldset: document.getElementById('c-filter__fieldset-type'),
    typeHeading: document.getElementById('c-filter__heading-type'),
    resetBtn: document.getElementById('c-filter__reset-categories-btn')
  };
  const inputEls = {
    genreInputs: uiEls.genreFieldset?.querySelectorAll('input[name=genre]'),
    levelInputs: uiEls.levelFieldset?.querySelectorAll('input[name=level]'),
    instrumentInputs: uiEls.instrumentFieldset?.querySelectorAll('input[name=instrument]'),
    typeInputs: uiEls.typeFieldset?.querySelectorAll('input[name=type]')
  }

  if (uiEls.genreFieldset && uiEls.genreHeading) {
    checkForCheckedFilters(inputEls.genreInputs, uiEls.genreFieldset);
    inputEls.genreInputs.forEach((el, _, arr) => {
      el.addEventListener('change', () => {
        checkForCheckedFilters(arr, uiEls.genreFieldset);
      })
    })
    uiEls.genreHeading.addEventListener('click', () => {
      checkForCollapseState(collapseState.genre, uiEls.genreFieldset);
      checkForBtn(collapseState, uiEls.resetBtn);
    })
  }
  if (uiEls.levelFieldset && uiEls.levelHeading) {
    checkForCheckedFilters(inputEls.levelInputs, uiEls.levelFieldset);
    inputEls.levelInputs.forEach((el, _, arr) => {
      el.addEventListener('change', () => {
        checkForCheckedFilters(arr, uiEls.levelFieldset);
      })
    })
    uiEls.levelHeading.addEventListener('click', () => {
      checkForCollapseState(collapseState.level, uiEls.levelFieldset);
      checkForBtn(collapseState, uiEls.resetBtn);
    })
  }
  if (uiEls.instrumentFieldset && uiEls.instrumentHeading) {
    checkForCheckedFilters(inputEls.instrumentInputs, uiEls.instrumentFieldset);
    inputEls.instrumentInputs.forEach((el, _, arr) => {
      el.addEventListener('change', () => {
        checkForCheckedFilters(arr, uiEls.instrumentFieldset);
      })
    })
    uiEls.instrumentHeading.addEventListener('click', () => {
      checkForCollapseState(collapseState.instrument, uiEls.instrumentFieldset);
      checkForBtn(collapseState, uiEls.resetBtn);
    })
  }
  if (uiEls.typeFieldset && uiEls.typeHeading) {
    checkForCheckedFilters(inputEls.typeInputs, uiEls.typeFieldset);
    inputEls.typeInputs.forEach((el, _, arr) => {
      el.addEventListener('change', () => {
        checkForCheckedFilters(arr, uiEls.typeFieldset);
      })
    })
    uiEls.typeHeading.addEventListener('click', () => {
      checkForCollapseState(collapseState.type, uiEls.typeFieldset);
      checkForBtn(collapseState, uiEls.resetBtn);
    })
  }


  // NOTE: Do not procede if it's not All Courses Page
  const showSortBtn = document.getElementById('show-sorting');

  if (!window.location.pathname.includes('/courses/')) {
    const productDataEl = document.getElementById('product-data');
    if (!productDataEl) {
      return;
    }

    const productListEl = document.getElementById('product-list');
    const productFilters = document.getElementById('product-filters');
    const showFiltersBtn = document.getElementById('show-filters');
    const applyFiltersBtn = document.getElementById('apply-filters');
    const resetFiltersBtns = document.querySelectorAll('.js-reset-filters');
    const productBtns = document.querySelectorAll('.c-filter__link');

    const products = JSON.parse(productDataEl.innerHTML);
    showSortBtn.style.display = 'none';

    if (Array.from(urlParams).length > 0) {
      // update filter list from query params
      hydrateForm(productFilters, urlParams, { uiEls, inputEls })
      // replace static list using parameters
      const filteredProducts = await filterList(products, urlParams);

      if (filteredProducts.length > 0) {
        replaceList(productListEl, filteredProducts);
        productListEl.classList.remove('not-found');
      } else {
        insertNotFound(productListEl);
      }
    }

    // setup click events for filter buttons
    applyFiltersBtn.addEventListener('click', event => {
      event.preventDefault();
      productFilters.classList.add('is-hidden');
    });
    resetFiltersBtns.forEach(el => el.addEventListener('click', event => {
      event.preventDefault();
      window.location.href = window.location.origin + window.location.pathname;
    }));
    showFiltersBtn.addEventListener('click', event => {
      event.preventDefault();
      productFilters.classList.remove('is-hidden');
    });
    productBtns.forEach(el => el.addEventListener('click', event => {
      event.preventDefault();
      const btnEl = event.currentTarget;
      if (!btnEl.classList.contains('is-active')) {
        // keep search values when navigating between products
        window.location.href = btnEl.href + document.location.search;
      }
    }));

    productFilters.addEventListener('change', async () =>
      await updateProductList(productFilters, productListEl, products));
      if (document.getElementById('load-more')) {
        document.getElementById('load-more').addEventListener('click', async (event) => {
          event.preventDefault();
          await loadMore(productFilters, productListEl, products);
        });
      }

    return;
  }

  // NOTE: Sorting & Course Improvements
  loaderInnerHtml = loadMoreWrapper.innerHTML;
  startLoadingSpinner(loadMoreWrapper, true);
  loadMoreWrapper.classList.add('loading');
  
  // const [newestCourses, popularCourses, trendCourses] = await Promise.all([getNewestCourses(), getPopularCourses(), getTrendCourses()]);
  const productsData = document.getElementById('product-data');
  if (!productsData) {
    return;
  }
  const products = JSON.parse(productsData.innerHTML);
  const trendCourses = [];
  const typedCoursesIds = {};
  const typedCourses = {};

  typedCoursesIds.popular = await getPopularCourses();
  getNewestCourses().then(value => {
    typedCoursesIds.newest = value;
    typedCourses.newest = buildTypedArray(products, typedCoursesIds.newest);
  });
  
  const sortPopover = document.getElementById('sorting-popover');
  const sortOptions = {
    popular: {
      isActive: true,
      el: document.querySelector(`.c-dropdown__link[data-value="sorting-popular"]`)
    },
    newest: {
      isActive: false,
      el: document.querySelector(`.c-dropdown__link[data-value="sorting-newest"]`)
    },
    default: {
      isActive: false,
    },
    search: {
      isActive: false,
    },
  }
  // const loadMoreCoursesBtn = document.getElementById('load-more-courses');
  const productListEl = document.getElementById('product-list');
  const dropdownState = {
    isHidden: true
  }
  // const sortingArraysObj = buildSortingArrays(products, {popularIds: popularCoursesIds });
  typedCourses.popular = buildTypedArray(products, typedCoursesIds.popular);
  let defaultCourses = [];

  if (trendCourses.length > 0 || urlParams.has('type')) {
    document.getElementById('c-filter__fieldset-type').style.display = 'block';
  }

  const productFilters = document.getElementById('product-filters');
  const showFiltersBtn = document.getElementById('show-filters');
  const applyFiltersBtn = document.getElementById('apply-filters');
  const resetFiltersBtns = document.querySelectorAll('.js-reset-filters');
  const productBtns = document.querySelectorAll('.c-filter__link');

  // NOTE: UI Initialization
  if (Array.from(urlParams).length > 0) {
    // update filter list from query params
    hydrateForm(productFilters, urlParams, { uiEls, inputEls })
  }

  // NOTE: if isAuth => show default courses, otherwise => select popular
  if (!isAuth) {
    if (urlParams.get('query') && urlParams.get('query') !== '') {
      sortOptions.popular.isActive = false;
      sortOptions.search.isActive = true;
      const decodedQuery = decodeURIComponent(urlParams.get('query'));
      const res = await getSearchProduct('course', 'query=' + encodeURIComponent(decodedQuery));
      typedCourses.search = buildTypedArray(products, res);
      await updateProductListCourses(productFilters, productListEl, typedCourses.search, trendCourses);
    } else if (sortOptions.popular.isActive) {
      await updateProductListCourses(productFilters, productListEl, typedCourses.popular, trendCourses);
    } else if (sortOptions.newest.isActive) {
      await updateProductListCourses(productFilters, productListEl, typedCourses.newest, trendCourses);
    }
  } else {
    defaultCourses = await getDefaultCourses();
    if (defaultCourses.length > 0) {
      typedCourses.default = buildTypedArray(products, defaultCourses);
    }

    if (urlParams.get('query') && urlParams.get('query') !== '') {
      sortOptions.popular.isActive = false;
      sortOptions.search.isActive = true;
      const decodedQuery = decodeURIComponent(urlParams.get('query'));
      const res = await getSearchProduct('course', 'query=' + encodeURIComponent(decodedQuery));
      typedCourses.search = buildTypedArray(products, res);
      await updateProductListCourses(productFilters, productListEl, typedCourses.search, trendCourses);
    } else if (defaultCourses.length > 0) {
      sortOptions.default.isActive = true;
      sortOptions.popular.isActive = false;
      await updateProductListCourses(productFilters, productListEl, typedCourses.default, trendCourses);
    } else if (sortOptions.popular.isActive) {
      await updateProductListCourses(productFilters, productListEl, typedCourses.popular, trendCourses);
    } else if (sortOptions.newest.isActive) {
      await updateProductListCourses(productFilters, productListEl, typedCourses.newest, trendCourses);
    }
  }
  finishLoadingSpinner(loadMoreWrapper, loaderInnerHtml, null);
  loadMoreWrapper.classList.remove('loading');
  loaderInnerHtml = '';

  for (const option in sortOptions) {
    if (sortOptions[option].isActive && sortOptions[option].el !== undefined) {
      sortOptions[option].el.classList.add('active');
      break;
    }
  }

  // setup click events for filter buttons
  applyFiltersBtn.addEventListener('click', event => {
    event.preventDefault();
    productFilters.classList.add('is-hidden');
  });
  resetFiltersBtns.forEach(el => el.addEventListener('click', event => {
    event.preventDefault();
    window.location.href = window.location.origin + window.location.pathname;
  }));
  showFiltersBtn.addEventListener('click', event => {
    event.preventDefault();
    productFilters.classList.remove('is-hidden');
  });
  productBtns.forEach(el => el.addEventListener('click', event => {
    event.preventDefault();
    const btnEl = event.currentTarget;
    if (!btnEl.classList.contains('is-active')) {
      // keep search values when navigating between products
      window.location.href = btnEl.href + document.location.search;
    }
  }));

  productFilters.addEventListener('change', async () => {
    if (sortOptions.search.isActive) {
      await updateProductListCourses(productFilters, productListEl, typedCourses.search, trendCourses);
    } else if (sortOptions.popular.isActive) {
      await updateProductListCourses(productFilters, productListEl, typedCourses.popular, trendCourses);
    } else if (sortOptions.newest.isActive) {
      await updateProductListCourses(productFilters, productListEl, typedCourses.newest, trendCourses);
    } else if (sortOptions.default.isActive) {
      await updateProductListCourses(productFilters, productListEl, typedCourses.default, trendCourses);
    }
  });

  // NOTE: Load More Courses
  if (document.getElementById('load-more-courses')) {
    document.getElementById('load-more-courses').addEventListener('click', async () => {
      if (sortOptions.search.isActive) {
        await loadMoreCourses(productFilters, productListEl, typedCourses.search, { loadMoreWrapper }, trendCourses);
      } else if (sortOptions.popular.isActive) {
        await loadMoreCourses(productFilters, productListEl, typedCourses.popular, { loadMoreWrapper }, trendCourses);
      } else if (sortOptions.newest.isActive) {
        await loadMoreCourses(productFilters, productListEl, typedCourses.newest, { loadMoreWrapper }, trendCourses);
      } else if (sortOptions.default.isActive) {
        await loadMoreCourses(productFilters, productListEl, typedCourses.default, { loadMoreWrapper }, trendCourses);
      }
    });
  }

  // NOTE: Sorting Event Listeners
  // On show dropdown
  showSortBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    dropdownState.isHidden = !dropdownState.isHidden;

    if (dropdownState.isHidden) {
      sortPopover.classList.add('hidden');
      document.body.removeEventListener('click', popoverHandler);
    } else if (!dropdownState.isHidden) {
      sortPopover.classList.remove('hidden');
      document.body.addEventListener('click', popoverHandler)
    }
  })

  // On sorting options select
  sortPopover.querySelectorAll('.c-dropdown__link').forEach(el => {
    el.addEventListener('click', async (e) => {
      const selectedOption = sortOptions[e.target.dataset.value.split('sorting-')[1]];
      const selectedOptionIsActive = selectedOption.isActive;

      Object.values(sortOptions).forEach(option => {
        if (option === selectedOption) return;
        if (option.el !== undefined) {
          option.el.classList.remove('active');
        }
        option.isActive = false;
      });
      if ((typedCourses.default && typedCourses.default.length > 0) || (typedCourses.search && typedCourses.search.length > 0)) {
        if (selectedOption.isActive) {
          selectedOption.el.classList.remove('active');
          selectedOption.isActive = false;
        } else {
          selectedOption.el.classList.add('active');
          selectedOption.isActive = true;
        }
      } else {
        selectedOption.el.classList.add('active');
        selectedOption.isActive = true;
        if (selectedOptionIsActive) {
          dropdownState.isHidden = true;
          sortPopover.classList.add('hidden');
          document.body.removeEventListener('click', popoverHandler);
          return;
        }
      }

      if (sortOptions.popular.isActive) {
        await updateProductListCourses(productFilters, productListEl, typedCourses.popular, trendCourses);
      } else if (sortOptions.newest.isActive) {
        await updateProductListCourses(productFilters, productListEl, typedCourses.newest, trendCourses);
      } else if (Object.values(sortOptions).findIndex(option => option.isActive) === -1) {
        if (typedCourses.search) {
          sortOptions.search.isActive = true;
          await updateProductListCourses(productFilters, productListEl, typedCourses.search, trendCourses);
        } else if (typedCourses.default) {
          sortOptions.default.isActive = true;
          await updateProductListCourses(productFilters, productListEl, typedCourses.default, trendCourses);
        } else {
          sortOptions.popular.isActive = true;
          await updateProductListCourses(productFilters, productListEl, typedCourses.popular, trendCourses);
        }
      }

      dropdownState.isHidden = true;
      sortPopover.classList.add('hidden');
      document.body.removeEventListener('click', popoverHandler);
    })
  })

  const popoverHandler = (e) => {
    if (e.target.dataset.role && e.target.dataset.role === 'sorting-popover') {
      return;
    }
    dropdownState.isHidden = true;
    sortPopover.classList.add('hidden');
    document.body.removeEventListener('click', popoverHandler);
  }
};

// NOTE: Sorting Functionality
const buildSearchArray = (products, searchIds) => {
  // NOTE: Search Courses
  let searchResultArray = [];
  if (searchIds) {
    const searchRearrangedArray = products.reduce((acc, product) => {
      const id = +(product.id);
      if (searchIds.includes(id)) {
        acc.push(product);
      }
      return acc;
    }, []);
    searchResultArray = searchRearrangedArray;
  }

  return searchResultArray;
}

const buildTypedArray = (products, typedIds) => {
  let popularResultArray = null;
  if (typedIds) {
    const popularRearrangedArray = typedIds.reduce((acc, id) => {
      const item = products.find(item => +(item.id) === id);
      if (item) {
        acc.push(item);
      }
      return acc;
    }, []);
    const popularRemainingItems = products.filter(item => !typedIds.includes(+(item.id)));
    popularResultArray = popularRearrangedArray.concat(popularRemainingItems);
  }

  return popularResultArray;
}

const buildSortingArrays = (products, {popularIds = null, newestIds = null, defaultIds = null}) => {
  // NOTE: Popular Courses
  let popularResultArray = null;
  if (popularIds) {
    const popularRearrangedArray = popularIds.reduce((acc, id) => {
      const item = products.find(item => +(item.id) === id);
      if (item) {
        acc.push(item);
      }
      return acc;
    }, []);
    const popularRemainingItems = products.filter(item => !popularIds.includes(+(item.id)));
    popularResultArray = popularRearrangedArray.concat(popularRemainingItems);
  }

  // NOTE: Newest Courses
  let newestResultArray = null;
  if (newestIds) {
    const newestRearrangedArray = newestIds.reduce((acc, id) => {
      const item = products.find(item => +(item.id) === id);
      if (item) {
        acc.push(item);
      }
      return acc;
    }, []);
    const newestRemainingItems = products.filter(item => !newestIds.includes(+(item.id)));
    newestResultArray = newestRearrangedArray.concat(newestRemainingItems);
  }

  // NOTE: Default Courses
  let defaultResultArray = null;
  if (defaultIds) {
    const defaultRearrangedArray = defaultIds.reduce((acc, id) => {
      const item = products.find(item => +(item.id) === id);
      if (item) {
        acc.push(item);
      }
      return acc;
    }, []);
    const defaultRemainingItems = products.filter(item => !defaultIds.includes(+(item.id)));
    defaultResultArray = defaultRearrangedArray.concat(defaultRemainingItems);
  }

  return { popular: popularResultArray || null, newest: newestResultArray || null, default: defaultResultArray || null };
}

const generateCardsTemplate = (products, page = null) => {
  let productTemplate = '';
  let newProds = products;
  if (page) {
    newProds = products.slice(0 + NumProductsToLoad * (page - 1), NumProductsToLoad * page);
  }
  newProds.forEach(el => {
    if (el) {
      productTemplate += `<div class="c-card c-card--course">
      <img
        class="c-card__thumbnail js-card-img"
        src="${el.image_url}"
        alt=""
        width="320"
        height="180"
        loading="lazy">
      <div class="c-card__detail">
        <h3 class="c-card__heading t-heading t-heading--xs">
          <a class="c-card__target js-card-slug js-card-title" href="/courses/${el.blob.slug}">
            ${(el.blob.artist.display_name) ? el.title : 'Best source of quality music instruction and resources available online - customer support team is really helpful too.'}
          </a>
        </h3>
        <span class="c-card__caption t-caption">
          ${(el.blob.artist.display_name) ? 'with' : ''}
          <span class="js-card-guru">
            ${(el.blob.artist.display_name) ? (el.blob.artist.display_name) : ''}
          </span>
        </span>
      </div>
    </div>`
    }
  })

  return productTemplate;
}

const checkForCheckedFilters = (inputArr, fieldset) => {
  const someSelected = Array.from(inputArr).some((el) => el.checked);
  if (someSelected) {
    fieldset.classList.add('selected');
  } else {
    fieldset.classList.remove('selected');
  }
}

const checkForCollapseState = (collapseState, fieldset) => {
  collapseState.isCollapsed = !collapseState.isCollapsed;

  if (collapseState.isCollapsed) {
    fieldset.classList.add('collapsed');
  } else if (!collapseState.isCollapsed) {
    fieldset.classList.remove('collapsed');
  }
}

const checkForBtn = (collapseState, resetBtn) => {
  if (Object.keys(collapseState).map((state) => collapseState[state]['isCollapsed']).includes(false)) {
    resetBtn.classList.remove('hidden');
  } else {
    resetBtn.classList.add('hidden');
  }
}

// NOTE: Courses Functionality
const updateProductListCourses = async (productFilters, productListEl, products, trendingIds) => {
  const formData = new FormData(productFilters);
  const urlParams = new URLSearchParams(formData);
  const filteredProducts = await filterListCourses(products, urlParams, trendingIds);

  if (filteredProducts.length > 0) {
    replaceList(productListEl, filteredProducts);
    productListEl.classList.remove('not-found');
  } else {
    insertNotFound(productListEl);
  }

  window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${urlParams}`));
};

const filterListCourses = async (data, urlParams, trendingIds, currentListLength = 0) => {
  const prodTypeEl = document.getElementById('current-product-type');
  const prodType = JSON.parse(prodTypeEl.innerHTML);
  // const query = urlParams.get('query');
  const genres = urlParams.has('genre') ? urlParams.getAll('genre') : null;
  const levels = urlParams.has('level') ? urlParams.getAll('level') : null;
  const instruments = urlParams.has('instrument') ? urlParams.getAll('instrument') : null;
  const types = urlParams.has('type') ? urlParams.getAll('type') : null;

  if (genres) {
    data = data.filter(p => p.blob.musical_style_names.some(v => genres.includes(v)))
  }
  if (instruments) {
    data = data.filter(p => p.blob.instrument_names.some(v => instruments.includes(v)))
  }
  if (levels && prodType !== 'gurus') {
    data = data.filter(p => levels.indexOf(p.blob.level) !== -1);
  }
  if (types) {
    data = data.filter(p => trendingIds.includes(+(p.id)));
  }
  // TODO: might need to return it
  // if (query) {
  //   const decodedQuery = decodeURIComponent(query);

  //   let res = null;
  //   if (prodType === 'courses') {
  //     res = await getSearchProduct('course', 'query=' + encodeURIComponent(decodedQuery));
  //   } else if (prodType === 'gurus') {
  //     res = await getSearchProduct('user/guru', 'query=' + encodeURIComponent(decodedQuery));
  //   } else if (prodType === 'sheet-music') {
  //     res = await getSearchProduct('song-books', 'query=' + encodeURIComponent(decodedQuery));
  //   }
    
  //   if (res) {
  //     data = buildSearchArray(data, res);
  //     console.log(data)
  //   }
  // }

  const sliceEnd = (currentListLength + NumProductsToLoad) >= data.length ? data.length : (currentListLength + NumProductsToLoad);
  
  if (sliceEnd === data.length) {
    // no more products to load
    document.getElementById('load-more-wrapper').classList.add('is-hidden');
  } else {
    // more products to load
    document.getElementById('load-more-wrapper').classList.remove('is-hidden');
  }

  updateProductAmount(data.length);
  const title = document.getElementById('c-product-list__title');
  const readableProdType = getReadableProdType(prodType);
  const queryString = urlParams.get('query');
  if (title && queryString !== null && queryString !== '') {
    title.innerHTML = `Displaying ${readableProdType} results for "${decodeURIComponent(queryString)}"`;
  }

  return data.slice(currentListLength, sliceEnd);
};

const loadMoreCourses = async (productFilters, productListEl, products, {loadMoreWrapper}, trendingIds) => {
  const currentListLength = productListEl.childElementCount
  const formData = new FormData(productFilters);
  const urlParams = new URLSearchParams(formData);
  const filteredProducts = await filterListCourses(products, urlParams, trendingIds, currentListLength);

  let productTemplate = generateCardsTemplate(filteredProducts);
  productListEl.insertAdjacentHTML('beforeend', productTemplate);

  const newLength = productListEl.childElementCount;
  if (newLength >= products.length) {
    loadMoreWrapper.classList.add('is-hidden');
  }
};

// NOTE: Not Courses Functionality
const loadMore = async (productFilters, productListEl, products) => {
  const currentListLength = productListEl.childElementCount
  const formData = new FormData(productFilters);
  const urlParams = new URLSearchParams(formData);
  const filteredProducts = await filterList(products, urlParams, currentListLength);
  appendToList(productListEl, filteredProducts);
};

const appendToList = (productListEl, data) => {
  productListEl.append(...data.map(buildListElement));
};

const hydrateElement = (element, urlParams) => {
  let queryParams = '';
  for (let [key, value] of urlParams.entries()) {
    if (key === 'query' && value !== '') {
      queryParams += `${value} `;
    }
  }
  queryParams = decodeURIComponent(queryParams.trimEnd());

  // if (queryParams !== '') {
  //   let currentProductType = 'Unknown Product';
  
  //   if (window.location.pathname.includes('/courses/')) {
  //     currentProductType = 'Course';
  //   } else if (window.location.pathname.includes('/gurus/')) {
  //     currentProductType = 'Guru';
  //   } else if (window.location.pathname.includes('/sheet-music/')) {
  //     currentProductType = 'Songbook';
  //   }

  //   // if (element) {
  //   //   element.innerHTML = `Displaying ${currentProductType} results for "${queryParams}"`;
  //   // }
  // }
}

const hydrateForm = (form, urlParams, { uiEls, inputEls } = null) => {
  let isChecked = false;
  for (let [key, value] of urlParams.entries()) {
    if (!form.elements.hasOwnProperty(key)) {
      // unknown element key, skip
      continue;
    }

    if (key === 'query') {
      form.elements[key].value = value;
      continue;
    }

    if (key === 'type') {
      isChecked = true;
      form.elements[key].checked = true;
      continue;
    }

    form.elements[key].forEach(e => {
      if (e.value === value) {
        isChecked = true;
        e.checked = true;
      }
    });
  }

  if (isChecked && uiEls && inputEls) {
    if (uiEls.genreFieldset && uiEls.genreHeading) {
      checkForCheckedFilters(inputEls.genreInputs, uiEls.genreFieldset);
    }
    if (uiEls.levelFieldset && uiEls.levelHeading) {
      checkForCheckedFilters(inputEls.levelInputs, uiEls.levelFieldset);
    }
    if (uiEls.instrumentFieldset && uiEls.instrumentHeading) {
      checkForCheckedFilters(inputEls.instrumentInputs, uiEls.instrumentFieldset);
    }
    if (uiEls.typeFieldset && uiEls.typeHeading) {
      checkForCheckedFilters(inputEls.typeInputs, uiEls.typeFieldset);
    }
  }
};

const updateProductList = async (productFilters, productListEl, products) => {
  const formData = new FormData(productFilters);
  const urlParams = new URLSearchParams(formData);
  const filteredProducts = await filterList(products, urlParams);

  if (filteredProducts.length > 0) {
    replaceList(productListEl, filteredProducts);
    productListEl.classList.remove('not-found');
  } else {
    insertNotFound(productListEl);
  }

  window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${urlParams}`));
};

const filterList = async (data, urlParams, currentListLength = 0) => {
  const prodTypeEl = document.getElementById('current-product-type');
  const prodType = JSON.parse(prodTypeEl.innerHTML);
  const query = urlParams.get('query');
  const genres = urlParams.has('genre') ? urlParams.getAll('genre') : null;
  const levels = urlParams.has('level') ? urlParams.getAll('level') : null;
  const instruments = urlParams.has('instrument') ? urlParams.getAll('instrument') : null;

  if (genres) {
    data = data.filter(p => p.blob.musical_style_names.some(v => genres.includes(v)))
  }
  if (instruments) {
    data = data.filter(p => p.blob.instrument_names.some(v => instruments.includes(v)))
  }
  if (levels && prodType !== 'gurus') {
    data = data.filter(p => levels.indexOf(p.blob.level) !== -1);
  }
  if (query) {
    const decodedQuery = decodeURIComponent(query);

    let res = null;
    if (prodType === 'courses') {
      res = await getSearchProduct('course', 'query=' + encodeURIComponent(decodedQuery));
    } else if (prodType === 'gurus') {
      res = await getSearchProduct('user/guru', 'query=' + encodeURIComponent(decodedQuery));
    } else if (prodType === 'sheet-music') {
      res = await getSearchProduct('song-books', 'query=' + encodeURIComponent(decodedQuery));
    }
    
    if (res) {
      data = buildSearchArray(data, res);
    }
  }

  const sliceEnd = (currentListLength + NumProductsToLoad) >= data.length ? data.length : (currentListLength + NumProductsToLoad);

  if (sliceEnd === data.length) {
    // no more products to load
    document.getElementById('load-more-wrapper').classList.add('is-hidden');
  } else {
    // more products to load
    document.getElementById('load-more-wrapper').classList.remove('is-hidden');
  }

  updateProductAmount(data.length);
  const title = document.getElementById('c-product-list__title');
  const readableProdType = getReadableProdType(prodType);
  const queryString = urlParams.get('query');
  if (title && queryString !== null && queryString !== '') {
    title.innerHTML = `Displaying ${readableProdType} results for "${decodeURIComponent(queryString)}"`;
  }

  return data.slice(currentListLength, sliceEnd);
};

const replaceList = (productListEl, data) => {
  if (productListEl.replaceChildren) {
    productListEl.replaceChildren(...data.map(buildListElement));
    return;
  }
  productListEl.innerHTML = '';
  productListEl.append(...data.map(buildListElement));
};

const buildListElement = (product) => {
  const template = document.getElementById('product-card-template');
  const clone = template.content.cloneNode(true);

  const currency = window.localStorage.getItem('currency');

  const cardGuruEl = clone.querySelector('.js-card-guru');
  const cardImgEl = clone.querySelector('.js-card-img')
  const cardSlugEl = clone.querySelector('.js-card-slug')
  const cardTitleEl = clone.querySelector('.js-card-title')
  const cardPricesEl = clone.querySelector('.js-card-prices');

  if (cardImgEl && product.image_url) {
    clone.querySelector('.js-card-img').src = product.image_url;
    clone.querySelector('.js-card-img').alt = product.title;
  }
  if (cardSlugEl && product.blob.slug) {
    cardSlugEl.href = clone.querySelector('.js-card-slug').href + product.blob.slug;
  }
  if (cardTitleEl) {
    clone.querySelector('.js-card-title').textContent = product.title;
  }
  if (cardGuruEl) {
    if (product.blob.artist) {
      cardGuruEl.textContent = product.blob.artist.display_name;
    } else if (product.blob.publisher) {
      cardGuruEl.textContent = product.blob.publisher.display_name;
    }
  }
  if (cardPricesEl && product.blob.prices) {
    cardPricesEl.querySelector('.js-price').dataset.eur = product.blob.prices.EUR;
    cardPricesEl.querySelector('.js-price').dataset.gbp = product.blob.prices.GBP;
    cardPricesEl.querySelector('.js-price').dataset.usd = product.blob.prices.USD;
    cardPricesEl.querySelector('.js-price').textContent = !!currency ? product.blob.prices[currency] : product.blob.prices.USD;
  }
  return clone;
};

const insertNotFound = (productListEl) => {
  productListEl.innerHTML = `<div class="c-product__not-found"><span class='c-product__not-found-header'>Sorry, we couldn't find any results.</span><br>
  <span class='c-product__not-found-subheader'>Try adjusting your search. Here are some ideas:</span>
  <span class="c-product__not-found-body">- Make sure all words are spelled correctly
  - Try different search terms and/or filters
  - Try more general search terms
  </span></div>`;
  productListEl.classList.add('not-found');
};

// NOTE: XHR Requests
const getPopularCourses = () => new Promise((resolve, reject) => {
  const xhr = createXHR({
      method: 'GET',
      endpoint: `/api/v2/course/popular-courses`,
  });

  xhr.onload = () => {
      switch (xhr.status) {
          case 200:
              resolve(JSON.parse(xhr.response));
              break;
          default:
              reject('[POPULAR COURSES ERROR]: ' + xhr.status);
              break;
      }
  };
});

const getTrendCourses = () => new Promise((resolve, reject) => {
  const xhr = createXHR({
      method: 'GET',
      endpoint: `/api/v2/course/trend-courses`,
  });

  xhr.onload = () => {
      switch (xhr.status) {
          case 200:
              resolve(JSON.parse(xhr.response));
              break;
          default:
              reject('[POPULAR COURSES ERROR]: ' + xhr.status);
              break;
      }
  };
});

const getNewestCourses = () => new Promise((resolve, reject) => {
  const xhr = createXHR({
      method: 'GET',
      endpoint: `/api/v2/course/newest-courses`,
  });

  xhr.onload = () => {
      switch (xhr.status) {
          case 200:
              resolve(JSON.parse(xhr.response));
              break;
          default:
              reject('[NEWEST COURSES ERROR]: ' + xhr.status);
              break;
      }
  };
});

const getDefaultCourses = () => new Promise((resolve, reject) => {
  const xhr = createXHR({
      method: 'GET',
      endpoint: `/api/v2/course/default-courses`,
  });

  xhr.onload = () => {
      switch (xhr.status) {
          case 200:
              resolve(JSON.parse(xhr.response));
              break;
          default:
              reject('[DEFAULT COURSES ERROR]: ' + xhr.status);
              break;
      }
  };
});

const getSearchProduct = (productType, query) => new Promise((resolve, reject) => {
  const xhr = createXHR({
      method: 'GET',
      endpoint: `/api/v2/${productType}/search?${query}`,
  });

  xhr.onload = () => {
      switch (xhr.status) {
          case 200:
              resolve(JSON.parse(xhr.response));
              break;
          default:
              reject('[SEARCH PRODUCT ERROR]: ' + xhr.status);
              break;
      }
  };
});

const updateProductAmount = (prodAmount) => {
  const prodTypeEl = document.getElementById('current-product-type');
  if(!prodTypeEl) return;

  const prodType = JSON.parse(prodTypeEl.innerHTML);
  let span = document.querySelector('.c-filter__fieldset').querySelector(`a[href="/${prodType}/"]`).querySelector('span');;

  if (span) {
    span.innerText = `(${prodAmount})`;
  }
}

const getReadableProdType = (prodType) => {
  if (prodType === 'courses') {
    return 'Courses';
  } else if (prodType === 'gurus') {
    return 'Gurus';
  } else if (prodType === 'sheet-music') {
    return 'Song Books';
  }
}

export default { init };
